import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const CepContext = React.createContext();

export const CepContextProvider = ({ children }) => {
  const [customCampaignDomain, setCustomCampaignDomain] = useState(undefined);

  return (
    <CepContext.Provider
      value={{
        customCampaignDomain,
        setCustomCampaignDomain
      }}
    >
      {children}
    </CepContext.Provider>
  );
};

CepContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export const useCepContext = () => {
  const { customCampaignDomain, setCustomCampaignDomain } = useContext(CepContext);

  return {
    customCampaignDomain,
    setCustomCampaignDomain
  };
};



// WEBPACK FOOTER //
// ./src/hooks/useCepContext.js